import React from "react";
import { Navigate } from "react-router-dom";
import { Grid, Paper, Typography } from "@mui/material";

import CenefaLogin from "../../../../images/cenefa-login.png";
import VideoBackground from "../../../../images/bg-login.mp4";
import FondoLogin from "../../../images/bg-login.jpg";
import ButtonWs from "../../../images/boton-zisoft.gif";
import "../../../css/login.css";
import { useLoginForm } from "../store/useLogin";
import { Input, Button } from "antd";
import { Controller } from "react-hook-form";
import { useWidth } from "../../../../libs/hooks";
import { DynamicIcon } from "../../../../libs/helpers";
import { MailOutlined } from "@ant-design/icons";
import { parameterGetNoAuthByCode } from "../../../../libs/apis";
import { LINK_MAIL_CODE, LINK_WHATSAPP_CODE } from "../../../../libs/constants";
 
export const Login = () => {
  const width = useWidth();
  const [videoLoaded, setVideoLoaded] = React.useState(false);
  const tokens = localStorage.getItem(process.env.REACT_APP_TOKEN!);
  const [hover, setHover] = React.useState(false);
  const { handleSubmit, errors, onSubmit, isProcessing, control } =
    useLoginForm();
  const [elWs, setElWs] = React.useState("");
  const [elMail, setElMail] = React.useState("");

  React.useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = async () => {
    try {
      const { data: dataWs } = await parameterGetNoAuthByCode(LINK_WHATSAPP_CODE);
      if (!dataWs) return;
      const { data: dataMail } = await parameterGetNoAuthByCode(LINK_MAIL_CODE);
      if (!dataMail) return;
      setElWs(dataWs.value);
      setElMail(dataMail.value);
    } catch (error: any) {
      console.log(error);
    }
  };

  if (tokens) {
    return <Navigate to="/" replace />;
  }

  const handleEmailClick = () => {
    window.location.href = `mailto:${elMail}?subject=Consulta&body=Hola, no puedo acceder a la plataforma de Securecontainer; ¿Podrías Brindarme la Información Necesaria?`;
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hola, no puedo acceder a la plataforma de Securecontainer; ¿Podrías Brindarme la Información Necesaria?"
    );
    const whatsappURL = `https://wa.me/${elWs}?text=${message}`;

    window.open(whatsappURL, "_blank"); // Abre WhatsApp en una nueva pestaña
  };

  return (
    <div className="login-container">
      {/* Imagen de fondo mientras se carga el video */}
      {!videoLoaded && (
        <img
          src={FondoLogin}
          alt="Fondo estático"
          className="video-background"
        />
      )}
      <video
        className="video-background"
        autoPlay
        loop
        muted
        playsInline
        onLoadedData={() => setVideoLoaded(true)}
      >
        <source src={VideoBackground} type="video/mp4" />
        Tu navegador no soporta videos HTML5.
      </video>
      {width === "xs" && (
        <div className="title-login">
          <Typography
            variant="h2"
            sx={{ fontWeight: "bold", color: "#25D228" }}
          >
            BIENVENIDO!
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "white",
              mt: 1,
              fontSize: "1.4rem",
              fontWeight: "bold",
              textAlign: "justify",
            }}
          >
            CREA TU TRAZABILIDAD DE MANERA SEGURA Y EFICIENTE
          </Typography>
        </div>
      )}
      <Grid
        container
        justifyContent="space-around"
        alignContent="center"
        spacing={2}
      >
        {width !== "xs" && (
          <Grid item sm={7} xs={12} textAlign="left">
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                color: "#25D228",
                fontSize: "6rem",
              }}
            >
              ¡BIENVENIDO!
            </Typography>
            <Typography
              variant="h2"
              sx={{ color: "white", mt: 2, fontWeight: "bold" }}
            >
              CREA TU TRAZABILIDAD DE MANERA SEGURA Y EFICIENTE
            </Typography>
          </Grid>
        )}
        <Grid item xl={2.5} lg={3} md={3.5} sm={4} xs={10}>
          <Paper
            sx={{
              background: "rgb(0, 0, 17, 0.60)",
              boxShadow: "9px 9px 5px -2px rgba(0, 0, 0, 0.59)",
              borderRadius: "30px",
            }}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                container
                justifyContent="center"
                alignContent="flex-start"
                className="login-sub-root"
              >
                <Grid item xs={10}>
                  <img
                    src={CenefaLogin}
                    width="100%"
                    height={width == "xs" ? 90 : 100}
                    alt="MALIMAX"
                    style={{
                      objectFit: "contain",
                      opacity: 1,
                      marginTop: width === "xs" ? "60px" : "30px",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={10}
                  sm={9}
                  md={8}
                  sx={{ mt: width === "xs" ? 2 : 3 }}
                >
                  <Controller
                    control={control}
                    name="user"
                    rules={{ required: true, min: 3, max: 20 }}
                    render={({ field: { value, onChange } }) => (
                      <Input
                        min={3}
                        max={20}
                        placeholder="USUARIO"
                        addonBefore={
                          <p
                            style={{
                              color: "white",
                              width: 50,
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <DynamicIcon
                              lib="tb"
                              icon="TbUserCircle"
                              color="white"
                              size={30}
                            />
                          </p>
                        }
                        value={value}
                        size="large"
                        onChange={onChange}
                      />
                    )}
                  />
                  {errors.user && (
                    <p style={{ color: "red" }}>
                      {(errors?.user?.message as React.ReactNode) ?? ""}
                    </p>
                  )}
                </Grid>
                <Grid item xs={10} sm={9} md={8} sx={{ mt: 2 }}>
                  <Controller
                    control={control}
                    name="password"
                    rules={{ required: true, min: 3, max: 30 }}
                    render={({ field: { value, onChange } }) => (
                      <Input.Password
                        min={3}
                        max={30}
                        size="large"
                        placeholder="CONTRASEÑA" 
                        addonBefore={
                          <p
                            style={{
                              color: "white",
                              width: 50,
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <DynamicIcon
                              lib="tb"
                              icon="TbLockSquareRoundedFilled"
                              color="white"
                              size={30}
                            />
                          </p>
                        }
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                  {errors.password && (
                    <p style={{ color: "red" }}>
                      {(errors?.password?.message as React.ReactNode) ?? ""}
                    </p>
                  )}
                </Grid>
                <Grid item xs={10} sm={9} md={8} sx={{ mt: 2, mb: 4 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    danger
                    size="large"
                    loading={isProcessing}
                    disabled={isProcessing}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    style={{
                      background: hover
                        ? "linear-gradient(90deg,rgb(120, 235, 122), #1A9E1D)"
                        : "linear-gradient(90deg, #1A9E1D,rgb(120, 235, 122))",
                      border: "none",
                      color: "white",
                      fontWeight: "bold",
                      width: "100%",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    INGRESAR
                  </Button>
                </Grid>
                {width !== "xs" ? (
                  <Grid item xs={10} sm={9} sx={{ mt: 3 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "white",
                        fontSize: "0.9rem",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      En caso de no tener acceso a la Plataforma, comunícate con
                      soporte por:
                    </Typography>
                    <div className="btons-footer">
                      <a className="bton-ws" onClick={handleWhatsAppClick}>
                        <img src={ButtonWs} width={120} alt="WS" />
                      </a>
                      <Button
                        icon={<MailOutlined />}
                        shape="circle"
                        size="large"
                        onClick={handleEmailClick}
                      />
                    </div>
                  </Grid>
                ) : null}
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
      {width === "xs" ? (
        <div className="footer-login">
          <Typography
            variant="body2"
            sx={{ color: "white", textAlign: "center", fontSize: "1.2rem" }}
          >
            En caso de no tener acceso a la Plataforma, comunícate con soporte
            por:
          </Typography>
          <div className="btons-footer">
            <a className="bton-ws" onClick={handleWhatsAppClick}>
              <img src={ButtonWs} width={120} alt="WS" />
            </a>
            <Button
              icon={<MailOutlined />}
              shape="circle"
              size="large"
              onClick={handleEmailClick}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};
